import { render, staticRenderFns } from "./GChatContact.vue?vue&type=template&id=7b3bdf40&"
import script from "./GChatContact.vue?vue&type=script&lang=js&"
export * from "./GChatContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports